export default {
  brand: require('../assets/images/brand.png'),
}
